// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('TopCallToActionJumpToGrid')

function TopCallToActionJumpToGrid(props) {
  return tag('a', {
    ref: props.forwardedRef,
    className: classNames(
      bem.block(),
      props.className
    ),
    href: props.href
  },
    'Explore Top Picks on Mix'
  )
}

module.exports = TopCallToActionJumpToGrid
